import React from 'react';
import { Card, Col, Divider, message, Row, Space, Typography, Input, Button, Tooltip } from 'antd';
import { CopyOutlined, ShopOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import DetailsViewStyles from "../../styles/DetailsViewStyles";
const { Text, Paragraph } = Typography;
const DetailsCard = ({ details, type, retailIds, setRetailIds }) => {
  const addRetailId = () => {
    setRetailIds([...retailIds, ""]);
  };

  const removeRetailId = (index) => {
    if (retailIds.length > 1) {
      const newRetailIds = retailIds.filter((_, i) => i !== index);
      setRetailIds(newRetailIds);
    }
  };

  const updateRetailId = (index, value) => {
    const newRetailIds = [...retailIds];
    newRetailIds[index] = value.trim() === "" ? null : value;
    setRetailIds(newRetailIds);
  };

  if (type === "impression") {
    details.supportMeasurements = [{ label: "Impressions" }];
  } else if (type === "publisher") {
    details.supportMeasurements = [{ label: "Page Views" }];
  }
  return (
    <Card 
      title={<Text strong>TAG DETAILS</Text>}
      style={DetailsViewStyles.card}
      headStyle={DetailsViewStyles.cardHead}
    >
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <Space direction="vertical" size={0}>
            <Text type="secondary">Tag ID</Text>
            <Space direction="horizontal">
              <Text
                style={DetailsViewStyles.textWithBreak}
              >
                {details.appId}
              </Text>
              <CopyOutlined
                onClick={() => {
                  navigator.clipboard.writeText(details.appId);
                  message.info('Tag ID copied to clipboard');
                }}
              />
            </Space>
          </Space>
        </Col>
        <Col span={8}>
          <Space direction="vertical" size={0}>
            <Text type="secondary">Advertiser</Text>
            <Text
              style={DetailsViewStyles.textWithBreak}
            >
              {details.advertiser}
            </Text>
          </Space>
        </Col>
        {type === "measurement" && (
          <Col span={8}>
            <Space direction="vertical" size={0}>
              <Text type="secondary">Cart Platform</Text>
              <Text
                style={DetailsViewStyles.textWithBreak}
              >
                {details.cart}
              </Text>
            </Space>
          </Col>
        )}
        {type === "publisher" && (
          <Col span={8}>
            <Space direction="vertical" size={0}>
              <Text type="secondary">Domain</Text>
              <Text
                style={DetailsViewStyles.textWithBreak}
              >
                {details.publisherDomain}
              </Text>
            </Space>
          </Col>
        )}
        {type === "impression" && (
          <Col span={8}>
            <Space direction="vertical" size={0}>
              <Text type="secondary">Platform</Text>
              <Text
                style={DetailsViewStyles.textWithBreak}
              >
                {details.impressionEnvironments
                  ? details.impressionEnvironments
                  : details.dsp}
              </Text>
            </Space>
          </Col>
        )}
        <Col span={24}>
          <Space direction="vertical" size={8}>
            <Text type="secondary">Supported Measurements</Text>
            <Row gutter={[16, 8]}>
              {details.supportMeasurements.map(measurement => (
                <Col key={measurement.label}>
                  <Text
                    style={DetailsViewStyles.measurementTag}
                  >
                    {measurement.label}
                  </Text>
                </Col>
              ))}
            </Row>
          </Space>
        </Col>
        <Col span={24}>
          <Divider style={DetailsViewStyles.divider} />
          <Space direction="vertical" size={12} style={DetailsViewStyles.retailIdsContainer}>
            <Space align="center">
              <Tooltip title="Retail IDs are unique identifiers used to track and identify specific retail locations or stores in your marketing campaigns. Each ID helps associate campaign performance data with individual retail outlets.">
                <ShopOutlined style={DetailsViewStyles.iconTooltip} />
              </Tooltip>
              <Text type="secondary" strong>Retail IDs</Text>
              <Button 
                type="text" 
                icon={<PlusOutlined />} 
                size="small"
                onClick={addRetailId}
                style={DetailsViewStyles.addButton}
              >
                Add ID
              </Button>
            </Space>
            <div style={DetailsViewStyles.retailIdsWrapper}>
              {retailIds.map((retailId, index) => (
                <div key={index} style={DetailsViewStyles.retailIdRow}>
                  <Input
                    placeholder={`Retail ID ${index + 1}`}
                    value={retailId || ""}
                    onChange={(e) => updateRetailId(index, e.target.value)}
                    style={DetailsViewStyles.retailIdInput}
                  />
                  {retailIds.length > 1 && (
                    <Button 
                      type="text" 
                      icon={<DeleteOutlined />}
                      size="small"
                      onClick={() => removeRetailId(index)}
                      style={DetailsViewStyles.deleteButton}
                    />
                  )}
                </div>
              ))}
            </div>
          </Space>
        </Col>
      </Row>
    </Card>
  );
};

export default DetailsCard;
